import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M19.99 2c0-1.1-.89-2-1.99-2H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h14l4 4zM16 12H4v-2h12zm0-3H4V7h12zm0-3H4V4h12z" />
, 'ActionCommentFilledx');
